import { useRestrictionDetailsQuery as useBaseRestrictionDetailsQuery } from 'hooks/queries/cluster-restrictions/useRestrictionDetailsQuery';

import type { WorkloadData } from '../types';

import { useCluster } from '@cast/shared-cluster-context-data-access';

type Props = {
  workloadData: WorkloadData | null;
};

export const useRestrictionDetailsQuery = ({ workloadData }: Props) => {
  const { cluster } = useCluster();

  return useBaseRestrictionDetailsQuery({
    organizationId: cluster.organizationId!,
    clusterId: cluster.id,
    resourceName: workloadData?.resourceName,
    resourceKind: workloadData?.resourceKind,
    resourceNamespace: workloadData?.resourceNamespace,
    enabled: !!workloadData && !!cluster.organizationId && !!cluster.id,
  });
};
